import { Link } from 'react-router-dom';
import { formatPrice, Look } from '../../data/home';
import { Arrow, ChiliIcon, SunIcon, VegIcon } from './icons';
import { OrderLink } from './links';

const MarkIcon = ({ kind }: { kind: Look['mark']['kind'] }) => {
  if (kind === 'chili') return <ChiliIcon />;
  if (kind === 'veg') return <VegIcon />;
  return <SunIcon />;
};

/**
 * The fixed furniture every look wears: price, name, Thai
 * name, one line from the menu, a mark, and an Order link. Same parts in the
 * same places, full-size over a photo or compact in the grid.
 */
const Caption = ({
  look,
  compact,
  as: Heading = 'h2',
}: {
  look: Look;
  compact?: boolean;
  as?: 'h2' | 'h3';
}) => (
  <div className={`sp-cap${compact ? ' sp-cap--compact' : ''}`}>
    <div className="sp-cap-top">
      <span className="sp-cap-price">{formatPrice(look.price)}</span>
    </div>
    <Heading className="sp-cap-name">
      {look.href ? <Link to={look.href}>{look.name}</Link> : look.name}
    </Heading>
    {look.thai && <p className="sp-cap-thai" lang="th">{look.thai}</p>}
    <p className="sp-cap-line">{look.description}</p>
    <div className="sp-cap-foot">
      <span className={`sp-mark sp-mark--${look.mark.kind}`}>
        <MarkIcon kind={look.mark.kind} />
        {look.mark.label}
      </span>
      <OrderLink className="sp-arrow-link" label={`Order ${look.name} online`}>
        <span>Order</span>
        <Arrow />
      </OrderLink>
    </div>
  </div>
);

export default Caption;
